import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { contactInfo } from "../mock";

const Footer = () => (
  <footer className="border-t border-white/10 bg-[#030508]">
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Voice-based customer support AI agents for hospitals. Smarter conversations, healthier tomorrow.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-cyan-400/20 bg-cyan-400/5 px-3 py-1 text-xs text-cyan-300">
            Serving GCC & Global Markets · Local Support, Global Standards
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-slate-300">Platform</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
            <li><Link to="/#capabilities" className="transition-colors hover:text-cyan-300">Advanced Capabilities</Link></li>
            <li><Link to="/industries/healthcare" className="transition-colors hover:text-cyan-300">Healthcare & Hospitals</Link></li>
            <li><Link to="/#impact" className="transition-colors hover:text-cyan-300">Business Impact</Link></li>
            <li><Link to="/#why-us" className="transition-colors hover:text-cyan-300">Why Arkision</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-slate-300">Arkision AI — GCC Office</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
              <span>{contactInfo.gccPartner.partner} — {contactInfo.gccPartner.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 shrink-0 text-cyan-400" />
              <a href={`mailto:${contactInfo.gccPartner.email}`} className="transition-colors hover:text-cyan-300">{contactInfo.gccPartner.email}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 shrink-0 text-cyan-400" />
              <a href={`tel:${contactInfo.gccPartner.phone.replace(/\s/g, "")}`} className="transition-colors hover:text-cyan-300">{contactInfo.gccPartner.phone}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-slate-300">India Office</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
              <span>{contactInfo.indiaOffice.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="h-4 w-4 shrink-0 text-cyan-400" />
              <a href={`mailto:${contactInfo.indiaOffice.email}`} className="transition-colors hover:text-cyan-300">{contactInfo.indiaOffice.email}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="h-4 w-4 shrink-0 text-cyan-400" />
              <a href={`tel:${contactInfo.indiaOffice.phone.replace(/\s/g, "")}`} className="transition-colors hover:text-cyan-300">{contactInfo.indiaOffice.phone}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-7 text-xs text-slate-500 sm:flex-row">
        <span>© {new Date().getFullYear()} Arkision AI. All rights reserved.</span>
        <span className="text-slate-400">Hail Towers EST. (HTE) — connecting the unconnected</span>
      </div>
    </div>
  </footer>
);

export default Footer;
